module.exports = __webpack_public_path__ + "img/chevleft.0b90203a.svg";